import { TextLink } from 'slab'
import { formatMoney } from 'utils'

import { QuoteDetailsItem } from './QuoteCostItem'
import { useSelfServeExplorerContext } from './QuoteSelfServeExplorerContext'

export function QuoteCostDetails () {
  const {
    willEnrollEmployees,
    totalMonthlyPlatformFee,
    perEmployeeCost,
    complianceFee,
    employeePortionOfInsurance,
    employerPortionOfInsurance,
    isLoading,
  } = useSelfServeExplorerContext()

  return (
    <div className='space-y-3'>
      <QuoteDetailsItem
        label='Estimated monthly health insurance costs'
        value={formatMoney(employerPortionOfInsurance)}
        isLoading={isLoading}
        tooltip="The estimated net amount you'll pay after employee contributions"
      />
      <QuoteDetailsItem
        label='Estimated monthly amount your employees will pay'
        value={formatMoney(employeePortionOfInsurance)}
        isLoading={isLoading}
        tooltip='The estimated amount your employees will contribute towards their health insurance'
      />
      <QuoteDetailsItem
        label='Monthly fees'
        value={formatMoney(totalMonthlyPlatformFee)}
        isLoading={isLoading}
        tooltip={<>For more information on Thatch pricing, see our <TextLink color='inherit' href='https://thatch.com/pricing' rel='noopener noreferrer' target='_blank'>pricing page</TextLink></>}
      />
      <div className='ml-4 space-y-1'>
        <QuoteDetailsItem
          label='Per employee cost'
          value={`${formatMoney(perEmployeeCost)} x ${
            willEnrollEmployees.length
          } employees`}
          variant='secondary'
          isLoading={isLoading}
          tooltip='The estimated total that will be billed for per-employee platform fees (based on number of active employees)'
        />
        <QuoteDetailsItem
          label='Compliance fee'
          value={formatMoney(complianceFee)}
          variant='secondary'
          isLoading={isLoading}
          tooltip='Monthly fee for administering your healthcare benefits, including handling payments, managing reporting, administering your plan, and handling payroll deductions'
        />
      </div>
    </div>
  )
}
